import { Component } from '@verndale/core';
import AOS from 'aos';


class CalloutMulti extends Component {
  setupDefaults() {
    this.dom = {};
    AOS.init();
  }

  addListeners() {}

}


export default CalloutMulti;
